"use strict";
// @ts-ignore
try {
    self['workbox:recipes:7.4.0'] && _();
}
catch (e) { }
